<a href="javascript:void(0)" class="closebtn" (click)="showhideFilters()"
  >&times;</a
>
<h2
  class="sidenav-ttile d-flex justify-content-between align-items-center px-4 py-2 mb-0"
>
  {{ "filters.filters" | translate }}
</h2>

<div id="accordion">
  <dq-accordion
    id="location"
    icon="icon-localizacion.svg"
    label="{{ 'filters.location' | translate }}"
  >
    <div class="card-body">
      <dq-combo
        id="ctryCombo"
        [items]="countries"
        [filterType]="FilterTypeEnum.COUNTRY"
        (selectedItemEvent)="changeCountry($event)"
        (unselectItemEvent)="unselectedCountries($event)"
        label="{{ 'filters.country' | translate }}"
      ></dq-combo>

      <dq-combo
        id="regionCombo"
        [items]="regions"
        [filterType]="FilterTypeEnum.REGION"
        (selectedItemEvent)="changeRegion($event)"
        (unselectItemEvent)="unselectedRegion($event)"
        label="{{ 'filters.region' | translate }}"
      ></dq-combo>

      <dq-combo
        id="subregionCombo"
        [items]="subregions"
        [filterType]="FilterTypeEnum.SUBREGION"
        (selectedItemEvent)="changeSubregion($event)"
        (unselectItemEvent)="unselectedSubregion($event)"
        label="{{ 'filters.subregion' | translate }}"
      ></dq-combo>
    </div>
  </dq-accordion>

  <dq-accordion
    id="products"
    icon="icon-producto.svg"
    label="{{ 'filters.product' | translate }}"
  >
    <div class="card-body">
      <dq-combo
        id="brandCombo"
        [items]="brands"
        [filterType]="FilterTypeEnum.BRAND"
        (selectedItemEvent)="changeBrand($event)"
        label="{{ 'filters.brand' | translate }}"
        (unselectItemEvent)="unselectedBrand($event)"
      ></dq-combo>

      <dq-combo
        id="subBrandCombo"
        [items]="subbrands"
        [filterType]="FilterTypeEnum.SUBBRAND"
        (selectedItemEvent)="changeSubBrand($event)"
        label="{{ 'filters.sub-brand' | translate }}"
        (unselectItemEvent)="unselectedSubbrand($event)"
      ></dq-combo>

      <dq-combo
        id="lineCombo"
        [items]="lines"
        [filterType]="FilterTypeEnum.LINE"
        (selectedItemEvent)="changeLine($event)"
        label="{{ 'filters.line' | translate }}"
        (unselectItemEvent)="unselectedLine($event)"
      ></dq-combo>
      <dq-combo
        id="formatCombo"
        [items]="formats"
        [filterType]="FilterTypeEnum.FORMAT"
        label="{{ 'filters.format' | translate }}"
        (selectedItemEvent)="changeFormat($event)"
        (unselectItemEvent)="unselectedFormat($event)"
      ></dq-combo>
    </div>
  </dq-accordion>

  <dq-accordion
    id="seller"
    icon="icon-vendedor.svg"
    label="{{ 'filters.vendor' | translate }}"
  >
    <div class="card-body">
      <dq-combo
        id="sellerCombo"
        [items]="sellers"
        [filterType]="FilterTypeEnum.SELLER"
        label="{{ 'filters.vendorName' | translate }}"
        (selectedItemEvent)="changeSeller($event)"
        (unselectItemEvent)="unselectedSeller($event)"
      ></dq-combo>
    </div>
  </dq-accordion>
</div>
